const certificateLogoByIssuer = {
  ogrencikariyeri: "/ikonlar/ogrencikariyeri_logo.jpg",
  istanbulgelisimuniversitesi: "/ikonlar/istanbul_gelisim.jpg",
  istanbulgelisimuniversity: "/ikonlar/istanbul_gelisim.jpg",
  istanbulgelisim: "/ikonlar/istanbul_gelisim.jpg",
  gelisimuniversitesi: "/ikonlar/istanbul_gelisim.jpg",
  btkacademy: "/ikonlar/btk.png",
  migros: "/ikonlar/migros.jpg",
  migrosgrupe: "/ikonlar/migros.jpg",
  migrosgruppe: "/ikonlar/migros.jpg",
  fordotosan: "/ikonlar/ford.jpg",
  gentekclub: "/ikonlar/gentek.jpg"
};

export const normalizeIssuer = (value = '') => value
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-z0-9]/g, '');

export const resolveCertificateIcon = (issuer, fallback = '') => {
  const normalized = normalizeIssuer(issuer);

  if (certificateLogoByIssuer[normalized]) {
    return certificateLogoByIssuer[normalized];
  }

  if (normalized.includes('istanbulgelisim') || normalized.includes('gelisim')) {
    return "/ikonlar/istanbul_gelisim.jpg";
  }

  return fallback || '';
};
